import script from "./UnitPopover.vue?vue&type=script&setup=true&lang=js"
export * from "./UnitPopover.vue?vue&type=script&setup=true&lang=js"

import "./UnitPopover.vue?vue&type=style&index=0&id=6ea06b09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea06b09"]])

export default __exports__